var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6086 14.3929H5.08685C3.64619 14.3929 2.47815 13.2249 2.47815 11.7842V5.2625C2.47815 3.82185 3.64619 2.65381 5.08685 2.65381H11.6086C13.0492 2.65381 14.2173 3.82185 14.2173 5.2625V11.7842C14.2173 13.2249 13.0492 14.3929 11.6086 14.3929Z",
    stroke: "currentColor",
    strokeWidth: 0.978261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88049 11.1324H9.81528",
    stroke: "currentColor",
    strokeWidth: 0.978261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14648 8.84839H10.5487",
    stroke: "currentColor",
    strokeWidth: 0.978261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41296 6.56616H11.2825",
    stroke: "currentColor",
    strokeWidth: 0.978261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.443690fb.svg";
export { ForwardRef as ReactComponent };